exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "footer[data-v-7f5fccfc]{position:static!important;height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important;-ms-flex:0 0 auto!important;flex:0 0 auto!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7f5fccfc","scoped":true,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/footer/IdoniaFooter.vue
// module id = 1044
// module chunks = 22